<template>
  <div class="content-box">
    <div class="d-flex justify-content-center">
      <b-spinner variant="success" label="Spinning" v-if="showSpinner" style="width: 3rem; height: 3rem"></b-spinner>
    </div>
    <b-card class="mb-3">
      <b-card-header>Complaint Information</b-card-header>
      <b-card-body>
        <ComplaintInfo :complaint="complaint" :loading="loadingopp" />
      </b-card-body>
    </b-card>

    <b-card>
      <b-card-header>Feedback History</b-card-header>
      <b-card-body>
        <FeedbackHistory :complaint="complaint" />
      </b-card-body>
    </b-card>
    
  </div>
</template>

<script>
import api from "@/api/api-v1-config";
import { BTabs, BTab, BSpinner, BCard } from "bootstrap-vue";
import ComplaintInfo from "./ComplaintInfo.vue";
import FeedbackHistory from "./FeedbackHistory"
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    BTabs,
    BTab,
    BSpinner,
    ComplaintInfo, FeedbackHistory, BCard
  },
  data() {
    return {
      token: localStorage.getItem("accessToken"),
      role: JSON.parse(localStorage.getItem("userData")).role,
      id: this.$route.params.id,
      showSpinner: false,
      options: [],
      logs: [],
      permissions: [],
      isAccountSettingRoute: false,
    };
  },

  computed: {
    ...mapGetters("complaintModule", {
      complaint: "complaintId",
      loadingopp: "loading",
    }),
  },


  methods: {
    ...mapActions("complaintModule", ["getComplaintsByIdAction", "removeComplaintsAction"]),
  },

  async mounted() {
    await this.getComplaintsByIdAction(this.id)
      .then((response) => {
       
      })
      .catch((response) => {
        console.log(response);
      });
  }
};
</script>
